// extracted by mini-css-extract-plugin
export default {"container":"SettingsInput_container__IT1kd","elements":"SettingsInput_elements__HpSOr"};